export enum Role {
    Admin = 'Admin',
}
